import * as React from "react";
import { cn } from "../../lib/utils";

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
	orientation?: "horizontal" | "vertical";
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
	({ className, orientation = "horizontal", ...props }, ref) => {
		return (
			<div
				ref={ref}
				role="separator"
				aria-orientation={orientation}
				className={cn(
					"bg-gray-200 dark:bg-white/[0.08] shrink-0",
					orientation === "horizontal" ? "h-px w-full" : "w-px h-full",
					className,
				)}
				{...props}
			/>
		);
	},
);
Separator.displayName = "Separator";

export { Separator };
